module.exports = __webpack_public_path__ + "static/Gotham-Book-66e67744d152caf39bccfb87ab4706d4.woff";